import React from 'react'
import { useNetworkingBrief } from '../NetworkingBriefProvider'
import { EditorHeading } from '../../ResumeBuilder/Editor/common'
import { EditorItemTextField, EditorItemProvider } from './EditorItemProvider'
import { useTranslation } from '~/hooks/useTranslation'

const GoalsEditor = () => {
  const { networkingBriefDocument: { goals } = {} } = useNetworkingBrief()
  const { t } = useTranslation('GoalsEditor')

  return (
    <EditorItemProvider sectionName="goals" item={goals}>
      <div>
        <EditorHeading>{t('networking_goals')}</EditorHeading>
        <p> {t('networking_goals_desc')}</p>
        <div className="grid grid-cols-1 gap-x-6 gap-y-4 md:grid-cols-2">
          <EditorItemTextField
            containerClassName="md:col-span-2"
            fieldName="networkingGoals"
            label={t('networking_goals_label')}
            areaClassName="h-[150px]"
          />
        </div>
      </div>
    </EditorItemProvider>
  )
}
export default GoalsEditor
